<template>
	<div class="row">
		<div class="small-12 medium-8 medium-offset-2">
			<div class="flex-video">
				<iframe v-bind:src="data.src.replace('watch?v=', 'embed/')" width="560" height="315" frameborder="0" allowfullscreen></iframe>
			</div>
		</div>
	</div>
</template>


<script>
export default {
	props: ['data']
}
</script>